import { render, staticRenderFns } from "./OffCoupons.vue?vue&type=template&id=4aab9ee9"
import script from "./OffCoupons.vue?vue&type=script&lang=js"
export * from "./OffCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports